module.exports = __webpack_public_path__ + "img/Imaginative Mind.37885d09.svg";